import React from "react";
import Typography from "../../../common/Typography/Typography";
import Button from "../../../common/Buttons/Button/Button";
import { SlideProps } from "../types";
import useAuthSession from "../../../../lib/auth/hooks/useAuthSession";

const IntroSlide = ({ nextSlide }: SlideProps) => {
    const { session } = useAuthSession({ required: true });
    const firstName = session?.user?.firstname;
    return (
        <div className="flex flex-col gap-1.5 pb-1">
            <Typography as="h2" variant="subTitle">
                Welcome to Vergo Hub{firstName ? `, ${firstName}!` : "!"} This is your new one-stop-shop, or 'Hub', for your pest control
                contract.
            </Typography>
            <Typography variant="paragraph">
                Vergo Hub provides you with up-to-date insight into your pest activity, actions, risk and more. You also get 24/7 access to
                your pest control data, for whenever you may need it.
            </Typography>
            <Typography variant="paragraph">
                Before you get started in your new end-to-end pest management platform, let's check that all of the details we have stored
                for your account are correct and while we're at it, let's get your password changed to something more secure and memorable!
            </Typography>
            <Button variant="primary" size="large" onClick={nextSlide}>
                Set up my account
            </Button>
        </div>
    );
};

export default IntroSlide;
